import { css } from "@emotion/react";

export const nameRow = css`
  display: flex;
  gap: 1rem;
`;

export const nameInput = css`
  flex: 1;
`;
